<div class="drawer-item-wrap">
    <div [id]="'nav-' + entity().id" class="drawer-item" [class.active]="isActive()" (click)="selectEntity()">
        <div class="drawer-item-content">
            <small
                class="sp-icon icon-chevron-right"
                style="display: block"
                [style.rotate]="showChildren() ? '90deg' : '0deg'"
            >
            </small>

            <img src="./assets/img/websites/lpc-tab-icon.svg" alt="lpc-tab-icon" />

            <div class="text-wrapper">
                <div class="text-item">{{ "control_tabs" | translate }}</div>
                <div class="id-item" [title]="'id: ' + displayId()">id: {{ displayId() }}</div>
            </div>
        </div>
    </div>
    <div dropdown #dropdown="bs-dropdown" class="btn-group dropdown dropdown-options">
        <button
            dropdownToggle
            type="button"
            class="btn btn-action dropdown-toggle"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span class="sp-icon icon-ellipsis"></span>
        </button>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
            <li role="menuitem">
                <a class="dropdown-item" (click)="copyTab()">
                    <span class="sp-icon icon-copy"> </span>
                    {{ "duplicate" | translate }}
                </a>
            </li>
            <li>
                <hr />
            </li>
            <li role="menuitem" (click)="removeTab()">
                <a>
                    <span class="sp-icon icon-bin color-danger"></span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>

@if (showChildren()) {
    <div class="drawer-item-children">
        @for (grid of grids(); track grid.id) {
            <web-navigation-grid-item
                [index]="$index"
                [entity]="grid"
                [selectedEntity]="selectedEntity()"
                [selectable]="false"
                [showActions]="false"
                (gridSelected)="onChildGridSelected($event)"
            />
        }
    </div>
}
